<!--
    `[min]`, `[max]` e `[step]` vêm ANTES de `[value]`: o Angular aplica as
    ligações na ordem escrita e o navegador sanitiza o valor contra os limites
    vigentes no momento da escrita.

    `--ai-slider-fill` (0 a 1) é lido pelo SCSS para desenhar o preenchimento do
    trilho. As legendas ficam ocultas para leitores de tela porque a faixa ativa
    já é anunciada em `aria-valuetext`.
-->
<div class="ai-slider" [class.ai-slider--disabled]="disabled()">
    @if (showValue()) {
        <span class="ai-slider__value" aria-hidden="true">
            {{ displayValue() }}
        </span>
    }

    <input
        #inputEl
        type="range"
        class="ai-slider__input"
        [id]="id()"
        [min]="min()"
        [max]="upperBound()"
        [step]="step()"
        [value]="value()"
        [disabled]="disabled()"
        [style.--ai-slider-fill]="fillRatio()"
        [attr.aria-label]="ariaLabel() || null"
        [attr.aria-valuetext]="valueText()"
        (input)="onInput($event)"
        (blur)="onBlur()"
    />

    @if (ranges().length > 0) {
        <div class="ai-slider__ranges" aria-hidden="true">
            @for (range of ranges(); track $index) {
                <span
                    class="ai-slider__range"
                    [class.ai-slider__range--active]="range === activeRange()"
                >
                    @if (range.icon) {
                        <ai-icon [fontIcon]="range.icon" />
                    }
                    <span class="ai-slider__range-label">{{ range.label }}</span>
                </span>
            }
        </div>
    }
</div>
